import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.settings.index'),
        name: 'settings.index',
        component: () =>
            import(
                /* webpackChunkName: "settings" */ '@/views/settings/Index.vue'
            ),
        props: true,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.settings.name', 2),
                    to: { name: 'settings.index' },
                    disable: false,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.settings.create'),
        name: 'settings.create',
        component: () =>
            import(
                /* webpackChunkName: "settings" */ '@/views/settings/Create.vue'
            ),
        props: true,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.settings.name', 2),
                    to: { name: 'settings.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: { name: 'settings.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.settings.edit') + '/:id',
        name: 'settings.edit',
        component: () =>
            import(
                /* webpackChunkName: "settings" */ '@/views/settings/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.settings.name', 2),
                    to: { name: 'settings.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.edit'),
                    to: { name: 'settings.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
